import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { SharedModule } from 'src/app/modules/shared/shared.module';
import { HttpErrorInterceptor } from 'src/app/modules/core/helpers/http-error.interceptor';
import { RetailerRoutingModule } from 'src/app/modules/retailer/retailer-routing.module';

import { LoginComponent } from 'src/app/modules/retailer/login/login.component';
import { ChangePasswordComponent } from 'src/app/modules/retailer/change-password/change-password.component';
import { DashboardComponent } from 'src/app/modules/retailer/dashboard/dashboard.component';
import { CreateCouponComponent } from 'src/app/modules/retailer/coupon/create-coupon/create-coupon.component';
import { CouponListComponent } from 'src/app/modules/retailer/coupon/coupon-list/coupon-list.component';
import { CouponProductListComponent } from './coupon/coupon-product-list/coupon-product-list.component';
import { DemoNationalCouponListComponent } from './coupon/demo-national-coupon-list/demo-national-coupon-list.component';
import { CouponReportComponent } from 'src/app/modules/retailer/reports/coupon-report/coupon-report.component';
import { CouponDetailedReportComponent } from './reports/coupon-detailed-report/coupon-detailed-report.component';
import { SalesDataComponent } from './reports/sales-data/sales-data.component';
import { RegionalCouponPaymentsComponent } from 'src/app/modules/retailer/payments/regional-coupon-payments/regional-coupon-payments.component';
import { NationalCouponPaymentsComponent } from 'src/app/modules/retailer/payments/national-coupon-payments/national-coupon-payments.component';
import { CreateCircularComponent } from 'src/app/modules/retailer/circular/create-circular/create-circular.component';
import { CircularListComponent } from 'src/app/modules/retailer/circular/circular-list/circular-list.component';
import { SmsCampaignListComponent } from './sms-campaign/sms-campaign-list/sms-campaign-list.component';
import { CreateSmsCampaignComponent } from './sms-campaign/create-sms-campaign/create-sms-campaign.component';
import { PushNotificationCampaignListComponent } from './push-notification-campaign/push-notification-campaign-list/push-notification-campaign-list.component';
import { CreatePushNotificationCampaignComponent } from './push-notification-campaign/create-push-notification-campaign/create-push-notification-campaign.component';
import { LoyaltyReportComponent } from './loyalty/loyalty-report/loyalty-report.component';
import { LoyaltySettingsComponent } from './loyalty/loyalty-settings/loyalty-settings.component';
import { UtilityComponent } from './utility/utility.component';

import { ReportFiltersComponent } from 'src/app/modules/retailer/components/report-filters/report-filters.component';
import { PreviewCircularComponent } from 'src/app/modules/retailer/components/preview-circular/preview-circular.component';
import { LoyaltyHomeComponent } from './loyalty/loyalty-home/loyalty-home.component';

@NgModule({
  declarations: [
    LoginComponent,
    ChangePasswordComponent,
    DashboardComponent,
    CreateCouponComponent,
    CouponListComponent,
    CouponProductListComponent,
    DemoNationalCouponListComponent,
    CouponReportComponent,
    CouponDetailedReportComponent,
    SalesDataComponent,
    RegionalCouponPaymentsComponent,
    NationalCouponPaymentsComponent,
    CreateCircularComponent,
    CircularListComponent,
    SmsCampaignListComponent,
    CreateSmsCampaignComponent,
    PushNotificationCampaignListComponent,
    CreatePushNotificationCampaignComponent,
    LoyaltyReportComponent,
    LoyaltySettingsComponent,
    UtilityComponent,

    ReportFiltersComponent,
    PreviewCircularComponent,
    LoyaltyHomeComponent,
  ],
  imports: [
    RetailerRoutingModule,
    CommonModule,
    SharedModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
  ],
  exports: [],
})
export class RetailerModule { }
